import store from "../index";

export default {
	namespaced: true,
	
	state: {
		color: null, // error, success, warning, info
		message: null,
		visible: false,
	},

	getters: {
		color(state) {
			return state.color;
		},
		message(state) {
			return state.message;
		},
		visible(state) {
			return state.visible;
		},
	},

	mutations: { // è il setter dello store, è sincrona, quindi meglio non usarla per fare chiamate api
		SET_COLOR (state, value) {
			state.color = value
		},
		SET_MESSAGE (state, value) {
			state.message = value
		},
		SET_VISIBLE (state, value) {
			state.visible = value
		},
	},

	actions: { // sono asincrone, posso fare chiamate api e richiamare poi la mutation
		show({ commit }, payload ) {
			store.commit('systemSnackbar/SET_COLOR', payload.color);
			store.commit('systemSnackbar/SET_MESSAGE', payload.message);
			store.commit('systemSnackbar/SET_VISIBLE', true);
		}
	}
}